import { Component, OnInit, computed, inject, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentService, ApContentPipe } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';
import { ApInputComponent } from '@ap/input';
import { ApDropdownComponent } from '@ap/dropdown';

import { Country, ForeignAddressForm } from './foreign-address.model';
import content from './foreign-address.content.json';

/**
 * @ngdoc component
 * @name ApForeignAddressComponent
 *
 * @param {FormGroup} addressForm The form group to bind to
 * @param {Country[]} countryList The list of countries to select from
 *
 */
@Component({
    selector: 'ap-foreign-address',
    templateUrl: './foreign-address.component.html',
    imports: [FormsModule, ReactiveFormsModule, ApInputComponent, ApDropdownComponent, ApContentPipe]
})
export class ApForeignAddressComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    /**
     * Required - The form group to bind to
     */
    public readonly addressForm = input.required<FormGroup<ForeignAddressForm>>();

    /**
     * Required - The list of countries to show
     */
    public readonly countryList = input.required<Country[]>();

    protected readonly countryNames = computed(() => {
        const list = this.countryList();
        return Array.isArray(list) ? list.map((c) => c.name) : [];
    });

    protected errorMessages: ErrorMessages;
    protected countryErrorMessages: ErrorMessages;

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.errorMessages = {
            required: this.contentService.get(`foreignAddress.error.required`),
            pattern: this.contentService.get(`foreignAddress.error.pattern`)
        };
        this.countryErrorMessages = {
            required: this.contentService.get('foreignAddress.country.error.required')
        };
    }
}
